






































































import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';

@Component({
  name: 'bpc-payment-config-form',
  components: {
    BpcFormProvider,
    BpcSwitch,
    BpcEntitySelect,
    BpcPageTitle,
  },
})
export default class SuperadminOptionsPage extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof BpcFormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  // @Prop({ type: String, default: '' }) readonly myStrProp: string;
  // @Prop({ type: Object, default() {return {};}}) readonly myObjectProp: MyInterface;

  // DATA
  public paymentMethodNames = [
    'wipay',
    'nepting',
    'manual_terminal',
    'electronic_sport_vouchers',
    'paper_sport_vouchers',
    'cheque',
    'stripe',
    'payfip',
    'virtual_wallet',
    'custom_1',
    'custom_2',
    'custom_3',
    'custom_4',
    'custom_5',
    'custom_6',
    'custom_7',
    'custom_8',
    'custom_9',
    'custom_10',
    'custom_11',
    'custom_12',
  ];

  formModelIndex: number = 0;

  public formModel = {
    enable_wipay: false,
    enable_nepting: false,
    enable_manual_terminal: false,
    enable_electronic_sport_vouchers: false,
    enable_paper_sport_vouchers: false,
    enable_cheque: false,
    enable_stripe: false,
    enable_payfip: false,
    enable_virtual_wallet: false,
    enable_custom_1: false,
    enable_custom_2: false,
    enable_custom_3: false,
    enable_custom_4: false,
    enable_custom_5: false,
    enable_custom_6: false,
    enable_custom_7: false,
    enable_custom_8: false,
    enable_custom_9: false,
    enable_custom_10: false,
    enable_custom_11: false,
    enable_custom_12: false,
    wipay_account_id: null,
    nepting_account_id: null,
    manual_terminal_account_id: null,
    electronic_sport_vouchers_account_id: null,
    paper_sport_vouchers_account_id: null,
    cheque_account_id: null,
    stripe_account_id: null,
    payfip_account_id: null,
    virtual_wallet_account_id: null,
    custom_1_account_id: null,
    custom_2_account_id: null,
    custom_3_account_id: null,
    custom_4_account_id: null,
    custom_5_account_id: null,
    custom_6_account_id: null,
    custom_7_account_id: null,
    custom_8_account_id: null,
    custom_9_account_id: null,
    custom_10_account_id: null,
    custom_11_account_id: null,
    custom_12_account_id: null,
  };

  public switchBaseConfig = {
    // fieldPath: 'modules.conditional_pricing_activated',
    // fieldReadPath: 'modules.conditional_pricing_activated',
    // name: 'conditional_pricing_activated',
    // label: 'core.modules.conditional_pricing_activated.label',
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
    // NOT TO SET fieldClass: 'core__modules-conditional-pricing-activated--input',
    // NOT TO SET errorClass: 'core__modules-conditional-pricing-activated--input-error',
    // NOT TO SET helpClass: 'core__modules-conditional-pricing-activated--input-help',
    // help: 'core.modules.conditional_pricing_activated.help',
    // NOT TO SET feedbackClass: 'core__modules-conditional-pricing-activated--input-feedback',
    // NOT TO SET feedback: 'core.modules.conditional_pricing_activated.feedback',
    // NOT TO SET labelClass: 'core__modules-conditional-pricing-activated--input-label',
  };

  public accountBaseConfig = {};

  modelLoaded: boolean = false;

  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}

  // COMPUTED

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // METHODS

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.formModelIndex++;
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.payment_config_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
    this.modelLoaded = true;
  }

  // WATCHERS
}
